import { useState } from 'react'
import { Typography } from 'antd'
import type { TableProps } from 'antd/es/table'

import { ALERT_TYPES } from 'portal/lib/constants/alertTypes'
import { Spinner } from 'portal/lib/primitives'

import { InfractionsTable } from './InfractionsTable'
import { useFilterLoader } from './useFilterLoader'
import { useInfractionEventsLoader } from './useInfractionEventsLoader'

interface InfractionsTableWrapperProps {
  startDate: string
  endDate: string
  showDismissed: 'true' | 'false'
  allowSelectionAndAction: boolean
  alertsType: (typeof ALERT_TYPES)[keyof typeof ALERT_TYPES]
}

type OnChange = NonNullable<TableProps<any>['onChange']>
type Filters = Parameters<OnChange>[1]

export const InfractionsTableWrapper = ({
  startDate,
  endDate,
  showDismissed,
  allowSelectionAndAction,
  alertsType
}: InfractionsTableWrapperProps) => {
  const [filteredInfo, setFilteredInfo] = useState<Filters>({})

  const moduleName = (() => {
    switch (alertsType) {
      case ALERT_TYPES.MATERIAL_CERTIFICATIONS:
        return 'delivery'
      case ALERT_TYPES.WASTE_COMPLIANCE:
        return 'waste'
      case ALERT_TYPES.SUBMISSION_ISSUES:
        return undefined
      default:
        return undefined
    }
  })()

  const {
    loading,
    error,
    reload,
    handlePageChange,
    hasNextPage,
    totalAlertsCount
  } = useInfractionEventsLoader(
    startDate,
    endDate,
    moduleName,
    showDismissed,
    filteredInfo
  )

  const { filtersloading, filtersError } = useFilterLoader(
    moduleName,
    alertsType
  )

  const { Text } = Typography

  return (
    <>
      {(error || filtersError) && (
        <Text type="danger">
          There was a problem loading this page, please try again
        </Text>
      )}
      {(loading || filtersloading) && <Spinner />}
      {!error && (
        <InfractionsTable
          allowSelectionAndAction={allowSelectionAndAction}
          reload={reload}
          moduleName={moduleName}
          handlePageChange={handlePageChange}
          hasNextPage={hasNextPage}
          totalAlertsCount={totalAlertsCount}
          filteredInfo={filteredInfo}
          setFilteredInfo={setFilteredInfo}
        />
      )}
    </>
  )
}
